module.exports = "<div class=\"question-wrapper\" [ngClass]=\"to.wrapperClasses.wrapperClass\">\r\n    <!--div class=\"question-label\" [ngClass]=\"to.wrapperClasses.wrapperLabel\" *ngIf=\"to && to.questionLabel\">\r\n        <label class=\"question-heading\">{{to.questionLabel}}</label>\r\n    </div-->\r\n    <div class=\"question-content\" [ngClass]=\"to.wrapperClasses.wrapperContent\">\r\n        <ng-container #fieldComponent></ng-container>\r\n    </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/stage/components/question-wrapper/question-wrapper.component.html
// module id = ./src/app/stage/components/question-wrapper/question-wrapper.component.html
// module chunks = main